import { Decimal, sumDecimals } from "@syla/shared/decimal";
import { PopulatedAssetHolding } from "@syla/shared/types/models/AssetHoldingBase";
import { HoldingsValue } from "../../../../helper/wallet/HoldingsValue";

export function getAccountHoldingsValue({
  holdingsValue,
  assetHoldings,
}: {
  holdingsValue: HoldingsValue | undefined;
  assetHoldings: PopulatedAssetHolding[] | undefined;
}): Decimal | undefined {
  if (!assetHoldings || assetHoldings.length === 0) {
    return Decimal.ZERO;
  } else {
    return sumDecimals(
      assetHoldings.map((holding) => {
        const marketValue = holdingsValue?.getAccountAssetValue({
          assetId: holding.asset._id,
        })?.marketValue;
        return marketValue || holding.cost;
      }),
    );
  }
}
